// Migrated onto the house MenuPanel chassis (DESIGN_LANGUAGE.md §7.7, Phase
// C.2). This is the accordion menu (Publish / Sync / Export headers that
// disclose tool sections), not a command list, so the CaptionTitle headers
// and the embedded tool sections keep their structure — only the shell
// re-homes. Deleted with the re-chassis:
// - the headers' `margin: '- -A2'` bleed: it stretched each header row
//   across the old hand-rolled `padding: 'Z1 A'` body; under MenuPanel's Y
//   padding a -A2 pull would overflow the panel and clip against the brand
//   Dropdown wrapper's overflow, so headers are now full-width rows inset Y
//   (canonical MenuPanel geometry, hover box included).
// - the two `Line` dividers (with their `ignoreChildProps` escapes) — the C
//   gap between the three captioned groups separates them (§7.7 default).
// The tool sections (PublishTools / SyncSuggestionsInPublish /
// ExportsInPublish) are shared read-only files still carrying their own
// legacy `margin: '- -Z2'` body-padding pull — neutralized per instance
// below at this consumption site; the shared files migrate with the
// bespoke-menus wave.
const Dropdownpublish = {
  extends: 'MenuPanel',
  childExtends: 'Flex',
  width: 'G3',
  gap: 'C',
  textAlign: 'start',
  childProps: {
    flow: 'y',
    gap: 'A',
    CaptionTitle: {
      extends: ['CaptionTitle', 'CanvasButton'],
      padding: 'A A2',
      round: 'radiusControl',
      Text: {},
      Icon: {
        margin: '- - - auto',
        icon: (el, s) =>
          s.activeOutput === el.parent.parent.key ? 'arrow angle up' : 'arrow angle down'
      },
      onClick: (ev, el, s) =>
        s.update({
          activeOutput: el.parent.key
        })
    },
    Section: {
      show: (el, s) => s.activeOutput === el.parent.key
    }
  },
  Publish: {
    key: 'publish',
    CaptionTitle: {
      Text: {
        text: '{{ publish.action.publish | polyglot }}'
      }
    },
    Section: {
      extends: 'PublishTools',
      margin: '0'
    }
  },
  Sync: {
    key: 'sync',
    CaptionTitle: {
      Text: {
        text: '{{ publish.action.sync | polyglot }}'
      }
    },
    Section: {
      extends: 'SyncSuggestionsInPublish',
      margin: '0'
    }
  },
  Export: {
    key: 'export',
    CaptionTitle: {
      Text: {
        text: '{{ publish.action.export | polyglot }}'
      }
    },
    Section: {
      extends: 'ExportsInPublish',
      margin: '0'
    }
  }
}

export { Dropdownpublish as 'Dropdown.Publish' }
